import React, { Component } from 'react'
import { object } from 'prop-types'

import { branch } from 'baobab-react/higher-order'
import storage from 'utils/storage'
import getQueryParam from 'utils/getQueryParam'

import Greeting from './Greeting'
import RecommendationList from './RecommendationList'

class AptitudeRecommendation extends Component {
  componentDidMount() {
    storage.select('common').merge({
      selectedIds: [],
    })
  }

  render() {
    const { currentUser, location: { search } } = this.props
    return (
      <div className="aptitude-recommendation">
        <Greeting name={currentUser.name} withAlert={getQueryParam('ref', search)}/>
        <RecommendationList />
        <style jsx>
          {`
            .aptitude-recommendation {
              padding-bottom: 72px;
            }
            :global(.alert>.close) {
              right: 0 !important;
            }
          `}
        </style>
      </div>
    )
  }
}

AptitudeRecommendation.propTypes = {
  location: object,
}

export { AptitudeRecommendation }

export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, AptitudeRecommendation)
